import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup, MeasuresType } from "../types/app.enums";

export class PeerGroupCapitalizationService extends BaseService {
  burgissCalcPeerGroupCapitalization(
    investId?: any[][],
    peerGroupId?: any[][],
    endDate?: any,
    currency?: string,
    returnConstituentCount?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      investId,
      peerGroupId,
      endDate,
      currency,
      returnConstituentCount,
      MeasuresType.CapitalizationPooled,
      dynamicParameter,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissCalcPeerGroupCapitalization",
      objRequest,
      this.APICONFIG.GETPRECENTRANKCAPITALIZATION,
      FunctionGroup.PeerGroupCapitalization
    );
  }
  createPayload(
    investId: any[][] = null,
    peerGroupId: any[][] = null,
    endDate: any = null,
    currency: string = null,
    returnConstituentCount: any = null,
    measure: string = null,
    dynamicParameter: any = null,
    alias: string = null
  ) {
    const peerGroupCapitalizationObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: String(peerGroupId).toUpperCase() == "ALL" ? "-1" : String(peerGroupId),
      percentile: null,
      currency: null,
      returnConstituentCount: returnConstituentCount,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: null,
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: null,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: endDate,
      year: null,
      indexID: "",
      premium: null,
      idType: null,
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: null,
      filter: null,
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: "",
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: dynamicParameter,
      universe: null,
      weight: null,
      commitment: null,
    };
    return peerGroupCapitalizationObject;
  }
}
